import { Box, Button, Icon, Theme } from "@outschool/backpack";
import { ActivitySubject } from "@outschool/business-rules";
import { faXLight } from "@outschool/icons";
import { useActivityString } from "@outschool/ui-components-website";
import * as React from "react";

import { SUBJECT_SELECTIONS } from "../consts";
import { onChangeMultiSelect } from "../utils";

interface MultiSelectSubjectsProps {
  selectedSubjects: ActivitySubject[];
  setSelectedSubjects: (subjects: ActivitySubject[]) => void;
}

export const MultiSelectSubjects = ({
  selectedSubjects,
  setSelectedSubjects,
}: MultiSelectSubjectsProps) => {
  const { translateThemeName } = useActivityString();

  const toggleMultiSelectButton = (subject: ActivitySubject) => {
    onChangeMultiSelect(selectedSubjects, subject, setSelectedSubjects);
  };

  return (
    <Box
      sx={(theme: Theme) => ({
        display: "flex",
        flexWrap: "wrap",
        gap: "1.6rem",
        [theme.breakpoints.up("md")]: {
          gap: "0.8rem",
        },
      })}
    >
      {SUBJECT_SELECTIONS.sort((a, b) => a.order - b.order).map(
        ({ subject, icon }) => {
          const isSelected = selectedSubjects.includes(subject);
          return (
            <Button
              key={subject}
              size={"small"}
              variant={isSelected ? "contained" : "outlined"}
              sx={{
                color: isSelected ? "common.white" : "common.black",
                ...(!isSelected && { borderColor: "neutral.light" }),
              }}
              onClick={() => toggleMultiSelectButton(subject)}
            >
              <Icon icon={icon} size="small" sx={{ mr: "0.25em" }} />
              {translateThemeName(subject)}
              {isSelected && (
                <Icon icon={faXLight} size="small" sx={{ ml: "0.25em" }} />
              )}
            </Button>
          );
        },
      )}
    </Box>
  );
};
